var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: "100",
        height: "100",
        viewBox: "0 0 48 48",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "#ff5722",
          d: "M6 6H22V22H6z",
          transform: "rotate(-180 14 14)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#4caf50",
          d: "M26 6H42V22H26z",
          transform: "rotate(-180 34 14)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#ffc107",
          d: "M26 26H42V42H26z",
          transform: "rotate(-180 34 34)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#03a9f4",
          d: "M6 26H22V42H6z",
          transform: "rotate(-180 14 34)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }